// Google Ads conversion tracking helper
// Fire on real conversion actions: quote form submit, phone click, WhatsApp click

const CONVERSION_ID = "AW-937484641/jxeRCMeSvWYQ4cKDvwM";

export function trackConversion(label = "conversion") {
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return;
  try {
    window.gtag("event", "conversion", {
      send_to: CONVERSION_ID,
      event_label: label,
    });
  } catch (e) {
    // silent
  }
}
